//mobile header
document.addEventListener("DOMContentLoaded", function() {
    var mobileMenuButton = document.querySelector('[data-collapse-toggle="mobile-menu-2"]');
    var mobileMenu = document.getElementById("mobile-menu-2");
    if (mobileMenuButton && mobileMenu) mobileMenuButton.addEventListener("click", function() {
        var isExpanded = mobileMenu.style.display !== "none";
        mobileMenu.style.display = isExpanded ? "none" : "block";
    });
    else console.error("Hata: Belirtilen elementler bulunamad\u0131.");
});
/////////////////SLIDER
var mainSlider = new Swiper(".js-main-slider", {
    slidesPerView: 3,
    spaceBetween: 30,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    breakpoints: {
        1920: {
            slidesPerView: 3,
            spaceBetween: 30
        },
        1028: {
            slidesPerView: 2.5,
            spaceBetween: 30
        },
        750: {
            slidesPerView: 2.2,
            spaceBetween: 30
        },
        310: {
            slidesPerView: 1,
            spaceBetween: 30
        }
    },
    pagination: {}
});
/////////////SCROLL
document.addEventListener("click", function(event) {
    var clickedElement = event.target;
    if (clickedElement.tagName === "a" && clickedElement.getAttribute("href") === "#scroll") {
        event.preventDefault();
        var formDiv = document.getElementById("scroll").offsetTop;
        window.scrollTo({
            top: formDiv - 200,
            behavior: "smooth"
        });
    }
});

//# sourceMappingURL=index.302e3c49.js.map
